import { core } from '@/core'
import Basic from '@basic'

const util = {
  template: {
    dropdown() {
      return $('<div class="popper cascader__dropdown"></div>')
    }
  },
  updater: {
    // 基本功能: 是否显示
    show(value, opt, tar, node) {
      if (value) {
        tar.unit.show()
        tar.shown()
      } else {
        tar.unit.hide()
        tar.hidden()
      }
    },
    // 基本功能: 内嵌
    slot(value, opt, tar, node) {
      tar.unit.html(value)
    },
    // 基本功能: 最小宽度
    minWidth(value, opt, tar, node) {
      if ($.type(value) === 'number') {
        tar.unit.css('min-width', value)
      }
    },
    // 基本功能: 最大宽度
    maxWidth(value, opt, tar, node) {
      if ($.type(value) === 'number') {
        tar.unit.css('max-width', value)
      }
    },
    // 基本功能: 宽度
    width(value, opt, tar, node) {
      if ($.type(value) === 'number') {
        tar.unit.css('width', value)
      }
    }
  }
}

export default class CascaderDropdown extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      show: false, // 基本功能: 是否显示
      slot: '', // 基本功能: 内嵌
      minWidth: null, // 基本功能: 最小宽度
      maxWidth: null, // 基本功能: 最大宽度
      width: null // 基本功能: 宽度
    }
    this.events = {
      shown: null,
      hidden: null
    }
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.dropdown(opt, this)
    const members = {}
    this.members = members
    this.unit = template
    core.update(util.updater, opt, this)
  }
}
